// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2O2gD","footer":"ModalFilter_footer__1FJUL"};